module.exports = __webpack_public_path__ + "static/media/gestión_de_proyectos_educativos.361bcd64.png";